export function modulu10Validation(value: string | number) {
  const charCount = 9;
  let mone: number = 0;
  let incNum: number;

  value = value.toString();

  if (/^[0]*$/.test(value)) {
    return false;
  }

  value = value.toString().padStart(charCount, '0');

  for (var i = 0; i < charCount; i++) {
    incNum = Number(value.charAt(i));
    incNum *= (i % 2) + 1;
    if (incNum > charCount) incNum -= charCount;
    mone += incNum;
  }

  return mone % 10 === 0;
}
